import { EDRAWMAX_PRODUCT_ENV } from "@/env";

import Vue from "vue";
import Router from "vue-router";
import Base from "./parts/base.vue";
import Files from "./parts/files.vue";
import Share from "./parts/share.vue";
import Teams from "./parts/Team/myTeams.vue";
// import NewPage from "./parts/NewPage.vue";
import PCView from "./parts/pcView/pcView.vue";
import TempCenter from "./parts/TempCenter.vue";
import Recycle from "./parts/recycle.vue";
import Collect from "./parts/collect.vue";
import Recent from "./parts/onlineView/recent.vue";
import BeShare from "./parts/onlineView/shareToMe.vue";
import Recommend from "./parts/recommend/recommend-new.vue";
// import Dropbox from './parts/dropbox.vue';
// import DropboxCloud from './parts/dropboxCloud.vue';
import Workbench from "./parts/onlineView/workbench.vue";
// import GoogleDrive from './parts/googleDrive.vue';

// pc
import HistoryView from "@/home/parts/Wb-historyView.vue";
import PublishFile from "@/home/parts/Wb-publishFile.vue";
import StarFile from "@/home/parts/Wb-star.vue";
import PCShare from "@/home/parts/pcShare.vue";
import ShareToMe from "@/home/parts/Wb-shareToMe.vue";
import AIList from "@/home/parts/aiList/AIList.vue";
import SearchPage from "@/home/parts/recommend/recommend-searchpage.vue";
// 海外 pc
import PCSearchTemplates from "@/home/parts/en/pc/search_templates/index.vue";
import PCHomeTemplates from "@/home/parts/en/pc/home/templates.vue";
import TagsBox from "@/home/parts/en/tagsBox.vue";

Vue.use(Router);
let routes = [
    {
        path: "/:lang?",
        component: Base,
        children: [
            {
                path: "/",
                name: "/",
                component: Recommend,
                // component: NewPage,
            },
            {
                path: "new",
                name: "new",
                component: Recommend,
                // component: NewPage,
            },
            {
                path: "new/ai-list",
                name: "AIList",
                component: AIList,
            },
            {
                path: "files",
                name: "Files",
                component: Files,
            },
            {
                path: "teams",
                name: "Teams",
                component: Teams,
            },
            {
                path: "dropbox",
                name: "Dropbox",
                component: () => import("./parts/dropboxCloud.vue"),
            },
            // {
            //     path: '/googledrive',
            //     name: 'Googledrive',
            //     component: GoogleDrive
            // },
            {
                path: "share",
                name: "Share",
                component: Share,
            },
            {
                path: "ShareToMe",
                name: "ShareToMe",
                component: ShareToMe,
            },
            {
                path: "newPage",
                name: "NewPage",
                component: TempCenter, //  内嵌客户端 --- 模版社区
            },
            {
                path: "store",
                name: "Store",
                component: TempCenter, // web端 --- 模版社区
            },
            {
                path: "search_templates",
                name: "search_templates",
                component: PCSearchTemplates,
            },
            {
                path: "pchome_templates",
                name: "home_templates",
                component: PCHomeTemplates,
            },
            {
                path: "tagsbox",
                name: "tagsbox",
                component: TagsBox,
            },
            {
                path: "recycle",
                name: "Recycle",
                component: Recycle,
            },
            {
                path: "collect",
                name: "Collect",
                component: Collect,
            },
            {
                path: "workbench",
                name: "Workbench",
                component: Workbench,
            },
            {
                path: "publishFile",
                name: "PublishFile",
                component: PublishFile,
            },
            {
                path: "starFile",
                name: "StarFile",
                component: StarFile,
            },
            {
                path: "recent",
                name: "Recent",
                component: Recent,
            },
            {
                path: "beshared",
                name: "beshared",
                component: BeShare,
            },
            // pc
            {
                path: "historyView",
                name: "HistoryView",
                component: HistoryView,
            },
            {
                path: "pcShare",
                name: "PCShare",
                component: PCShare,
            },
            {
                path: "pcFile",
                name: "pcFile",
                component: PCView,
            },
            {
                path: "search-result",
                name: "SearchPage",
                component: SearchPage,
            },
        ],
    },
];
if (EDRAWMAX_PRODUCT_ENV == "private") {
    const activePath = ["/", "new", "files", "teams", "share", "newPage", "recycle", "workbench"];
    routes[0].children = routes[0].children.filter((item) => activePath.includes(item.path));
}

const router = new Router({
    base: process.env.NODE_ENV === "production" ? `${window.GLOBAL.HTTP_BASE_PATH}/` : "/",
    mode: "history",
    routes: routes,
});
router.beforeEach((to, from, next) => {
    if (to.matched.length == 0) {
        next("/");
        return;
    }
    next();
});

export default router;
